import InventoryService from "../services/Inventory.service";

const state = {
	responseSuccess: null,
	getByInventoryRes: null,
	detail: null,
	returnError: false,
	currentInventory: null,
	inventoryById: null,
	inventoryStartError: false,
	saveInventoryError: false,
	saveInventoryErrorMessage: '',
	finishInventoryError: false,
	finishInventoryErrorMessage: '',
	deleteInventoryError: false,
	deleteInventoryErrorMessage: '',
	items: [],
	loading: true,
	columns: [
		{
			key: 'id',
			label: 'inventory.index',
			sortable: true,
			class: 'w-20',
			visible: true,
			changebale: false
		},
		{
			key: 'inventoryNumber',
			label: 'inventory.number',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'category',
			label: 'inventory.category',
			sortable: true,
			visible: true,
			changebale: false
		},

		{
			key: 'department',
			label: 'inventory.department',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'startDate',
			label: 'inventory.startDate',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'finishDate',
			label: 'inventory.finishDate',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'description',
			label: 'inventory.description',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'responsible',
			label: 'inventory.responsible',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'main',
			label: 'is_main',
			visible: true,
			changebale: false
		},
		{
			key: 'actions',
			label: 'inventory.actions',
			class: 'table_actions',
			sortable: true,
			visible: true,
			changebale: false
		}



	]
};

const getters = {
	fetchDetail(state) {
		return state.detail;
	},
	listInventory(state) {
		return state.items;
	},
	getColumns(state) {
		return state.columns;
	}

};

const actions = {

	async storeInventory({commit}, data) {
		try {
			commit('setLoading', true);
			const detail = await InventoryService.store(data);
			commit('setDetail', detail)
			commit('setLoading', false);
			commit('setInventoryStartError', {message: false, boolean: true});
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setLoading', false);
			commit('setInventoryStartError', {message: response.message, boolean: true});
			return false;
		}
	},
	async saveVozvratForInventory({commit}, data) {
		try {
			const list = await InventoryService.saveInventoryForVozvrat(data);
			commit('setResponse', false)
		} catch (e) {
			commit('setResponse', true)
			return false;
		}
	},
	async saveBoynigaQoyishForInventory({commit}, data) {
		try {
			const list = await InventoryService.saveInventoryForBoynigaQoyish(data);
			commit('setResponseBoynigaQoyish', false)
		} catch (e) {
			commit('setResponseBoynigaQoyish', true)
			return false;
		}
	},
	async saveInventoryList({commit}, data) {
		try {
			commit('setLoading', true);
			const list = await InventoryService.saveInventorList(data);
			await commit('setSaveInventoryError', {message: false, boolean: false});
			await commit('setResponseInventoryList', list)
			await commit('setLoading', false);
		} catch (e) {
			commit('setLoading', false);
			if (e.request) {
				if (e.request.response) {
					let response = JSON.parse(e.request.response);
					commit('setSaveInventoryError', {message: response.message, boolean: true});
				}
			}
			return false;
		}
	},
	async saveSpisatStore({commit}, data) {
		try {
			const list = await InventoryService.saveSpisatService(data);
			commit('setResponseSpisat', false)
		} catch (e) {
			commit('setResponseSpisat', true)
			return false;
		}
	},
	async getInventoryById({commit}, inventoryId) {
		try {
			const response = await InventoryService.getInventryByIdService(inventoryId);
			commit('setInventoryById', response.data)
		} catch (e) {
			return false;
		}
	},
	async getInventoryItemsById({commit}, inventoryId) {
		try {
			const list = await InventoryService.getInventryItemsByIdService(inventoryId);
			commit('setResponseInventoryItemsById', list)
		} catch (e) {
			return false;
		}
	},
	getInventoryId({commit}, currentInventoryForEdit) {
		commit('setLoading', true);
		commit('setCurrentInventory', currentInventoryForEdit);
	},


	async fetchInventory({commit}, data) {
		try {
			commit('setLoading', true);
			const list = await InventoryService.list(data);
			commit('setList', list)
			commit('setLoading', false);
		} catch (e) {
			commit('setLoading', false);
			return false;
		}
	},
	async finishInventory({commit}, inventoryId) {
		try {
			const data = await InventoryService.finish(inventoryId);
			commit('setFinishInventory', data);
			commit('setFinishInventoryError', {message: '', boolean: false});
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setFinishInventoryError', {message: response.message, boolean: true});
			return false;
		}
	},
	async inventoryDelete({commit}, inventoryId) {
		try {
			const list = await InventoryService.deleteInventory(inventoryId);
			commit('setDeleteInventoryError', {message: '', boolean: false});
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setDeleteInventoryError', {message: response.message, boolean: true});
			return false;
		}
	},
}


const mutations = {
	setLoading(state, boolean) {
		state.loading = boolean;
	},

	setResponseSpisat(state, boolean) {
		state.returnError = boolean;
	},
	setResponseBoynigaQoyish(state, boolean) {
		state.returnError = boolean;

	},
	setResponse(state, boolean) {
		state.returnError = boolean;
	},

	setFinishInventory(state, data) {
	},
	setFinishInventoryError(state, msgAndBooleanObj) {
		state.finishInventoryError = msgAndBooleanObj.boolean;
		state.finishInventoryErrorMessage = msgAndBooleanObj.message;
	},
	setDeleteInventoryError(state, msgAndBooleanObj) {
		state.deleteInventoryError = msgAndBooleanObj.boolean;
		state.deleteInventoryErrorMessage = msgAndBooleanObj.message;
	},
	setResponseInventoryList(state, response) {
		state.responseSuccess = response.data;
	},
	setCurrentInventory(state, inventory) {
		state.currentInventory = inventory;
	},
	setDetail(state, data) {
		state.detail = data;
	},
	setResponseInventoryItemsById(state, response) {
		state.getByInventoryRes = response.data;
	},
	setInventoryById(state, inventoryById) {
		state.inventoryById = inventoryById;
		state.currentInventory = inventoryById;
	},

	setInventoryStartError(state, obj) {
		state.inventoryStartError = obj.message;
	},
	setSaveInventoryError(state, msgAndBooleanObj) {
		if (msgAndBooleanObj.boolean) {
			state.responseSuccess = null;
		}
		state.saveInventoryError = msgAndBooleanObj.boolean;
		state.saveInventoryErrorMessage = msgAndBooleanObj.message;
	},
	setList(state, data) {
		state.items = data;
	}
};

export const inventory = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
